export default {"src":"/_next/static/media/icon-photo-search.c59ae506.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};